// extracted by mini-css-extract-plugin
export default {"inputComp":"Style_inputComp__CEMnU","readOnlyClass":"Style_readOnlyClass__BJaQP","ErrorField":"Style_ErrorField__SfsQO"};